<template>
  <div class="flex items-center">
    <img class="my-2 h-6 w-auto pr-6" src="/Disguise_Logo_New.svg" />
  </div>
</template>

<script setup></script>
